<template>
  <div class="text-center">
    <BSpinner variant="light" class="mb-2" />
    <p class="text-white mb-0">{{ $t('Webportal.Dashboard.Loading') }}...</p>
  </div>
</template>
